module.exports = __webpack_public_path__ + "static/media/redpull.e6f1ccad.jpg";